/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {

    export class MeevoReferenceValue implements angular.IDirective {

        restrict = "E";
        require = "ngModel";
        scope = {
            ngModel: "=",
            referenceType: "@",
            contentKey: "@",
            referenceStyle: "@?"
        }

        template = `<div>
                      <label translate="{{::contentKey}}"></label>
                      <div style="{{referenceStyle}}">{{displayName}}</div>
                    </div>`;


        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes): void => {
            let str: string = scope.referenceType;
            let refEnumType: Model.EnumTypeEnum = Model.EnumTypeEnum[str];

            if (refEnumType === undefined) {
                alert(`Invalid reference-type '${str}' specified in meevo-reference-value.\n\nPlease specify a valid value contained within Model.EnumTypeEnum`);
                return;
            }

            this.dataService.getEnumList(refEnumType)
                .then((data: any) => {
                    var foundMatch = false;
                    let match : any = _.findWhere(data, { id: scope.ngModel });
                    if (match != undefined) {
                        scope.displayName = match.displayName;
                        foundMatch = true;
                    }
                    if (!foundMatch) {
                        scope.displayName = "";
                    }
                });

            scope.$watch(() => scope.ngModel, (newVal: any, oldVal: any) => {

                if (newVal != oldVal) {
                    this.dataService.getEnumList(refEnumType)
                        .then((data: any) => {
                            var foundMatch = false;
                            let match: any = _.findWhere(data, { id: scope.ngModel });
                            if (match != undefined) {
                                scope.displayName = match.displayName;
                                foundMatch = true;
                            }
                            if (!foundMatch) {
                                scope.displayName = "";
                            }
                        });
                }

            });
        }

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new MeevoReferenceValue(dataService);
            };

            directive.$inject = ["meevo.components.common.DataService"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoReferenceValue", MeevoReferenceValue.factory());
}